/**
 * The web's one place for «today». Owner, 30.10.2026: «считать по UTC а отображать по таймзоне клиента / шоу».
 *
 *  - A MOMENT ("Emailed 13:02", "Saved", last seen, history) is a UTC instant the server sends; the browser formats it in ITS OWN zone
 *    (`format-datetime.ts`), never a fixed one.
 *  - A show's DAY is a date on the wall of the show's place: «past» is read in the show's zone (`isPastIn`, `@scb/schema` - the same
 *    function the server answers the Past pill with), so every viewer sees the same list.
 *  - The VIEWER's own today (`viewerToday`) is for what is the viewer's: the ring on a calendar, the first month of a picker.
 */
import { DEFAULT_SHOW_ZONE, isPastIn, resolveZone, todayIn } from "@scb/schema";

export { DEFAULT_SHOW_ZONE, isPastIn, todayIn };

/** The IANA zone the browser runs in (the venue default when the runtime will not say). */
export function viewerZone(): string {
  return resolveZone(Intl.DateTimeFormat().resolvedOptions().timeZone);
}

/** Today (`YYYY-MM-DD`) on the viewer's own wall clock. */
export function viewerToday(now: Date = new Date(), zone: string = viewerZone()): string {
  return todayIn(zone, now);
}

/** The zone a show's days are on the wall of: its venue's, else the venue default. */
export function showZone(venue: { timeZone?: string | null } | null | undefined): string {
  return resolveZone(venue?.timeZone);
}
